import React from 'react';
import { useTranslation } from 'react-i18next';

export default function ContentPanel({ contentBlock, progress, onNext }) {
  const { t } = useTranslation('session');

  if (!contentBlock) return null;

  return (
    <div className="content-panel">
      <div className="progress-bar">
        <div className="progress-fill" style={{ width: `${progress * 100}%` }} />
      </div>

      <h3 className="content-title">{t('reading_content')}</h3>

      <div className="content-body" dangerouslySetInnerHTML={{
        __html: contentBlock.content
          .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
          .replace(/\n/g, '<br/>')
      }} />

      <button className="btn-primary" onClick={onNext}>
        {t('next', { ns: 'common' })}
      </button>
    </div>
  );
}
